import { yieldToMain } from './yieldToMain';

// UTF16 decoder compatible with lz-string (Pieroxy, WTFPL v2).
export async function decompressLegacyUTF16(input) {
  if (!input) return null;
  const dictionary = [0, 1, 2];
  const output = [];
  let value = input.charCodeAt(0) - 32;
  let position = 16384;
  let index = 1;
  const readBits = (count) => {
    let bits = 0;
    for (let bit = 0; bit < count; bit += 1) {
      if (value & position) bits |= 1 << bit;
      position >>= 1;
      if (!position) {
        position = 16384;
        value = input.charCodeAt(index++) - 32;
      }
    }
    return bits;
  };
  const first = readBits(2);
  if (first === 2) return '';
  if (first !== 0 && first !== 1) return null;
  let previous = String.fromCharCode(readBits(first === 0 ? 8 : 16));
  dictionary[3] = previous;
  output.push(previous);
  let size = 4;
  let width = 3;
  let remaining = 4;
  let deadline = performance.now() + 4;
  let iterations = 0;
  while (index <= input.length) {
    let code = readBits(width);
    if (code === 2) return output.join('');
    if (code === 0 || code === 1) {
      dictionary[size++] = String.fromCharCode(readBits(code === 0 ? 8 : 16));
      code = size - 1;
      remaining -= 1;
    }
    if (remaining === 0) {
      remaining = 2 ** width;
      width += 1;
    }
    const entry = dictionary[code] || (code === size ? previous + previous.charAt(0) : null);
    if (entry === null) return null;
    output.push(entry);
    dictionary[size++] = previous + entry.charAt(0);
    remaining -= 1;
    previous = entry;
    if (remaining === 0) {
      remaining = 2 ** width;
      width += 1;
    }
    iterations += 1;
    if (iterations % 128 === 0 && performance.now() >= deadline) {
      await yieldToMain();
      deadline = performance.now() + 4;
    }
  }
  return null;
}

export async function parseLegacyJSON(json) {
  if (!json) return null;
  const text = json.trim();
  if (text[0] !== '[') return JSON.parse(text);
  const result = [];
  let start = 1;
  let depth = 0;
  let quoted = false;
  let escaped = false;
  let deadline = performance.now() + 4;
  for (let i = 1; i < text.length; i += 1) {
    const char = text[i];
    if (quoted) {
      if (escaped) escaped = false;
      else if (char === '\\') escaped = true;
      else if (char === '"') quoted = false;
    } else if (char === '"') quoted = true;
    else if (char === '[' || char === '{') depth += 1;
    else if (char === ']' && depth === 0) {
      const tail = text.slice(start, i).trim();
      if (tail) result.push(JSON.parse(tail));
      else if (result.length) throw new SyntaxError('Invalid JSON array');
      if (i !== text.length - 1) throw new SyntaxError('Invalid JSON array');
      return result;
    } else if (char === ']' || char === '}') depth -= 1;
    else if (char === ',' && depth === 0) {
      result.push(JSON.parse(text.slice(start, i)));
      start = i + 1;
    }
    if (i % 1024 === 0 && performance.now() >= deadline) {
      await yieldToMain();
      deadline = performance.now() + 4;
    }
  }
  throw new SyntaxError('Invalid JSON array');
}
